import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
interface TrustBadgeProps {
  type: 'WIC' | 'EBT' | 'USDA';
  size?: 'sm' | 'md';
}
export function TrustBadge({
  type,
  size = 'md'
}: TrustBadgeProps) {
  const configs = {
    WIC: {
      bg: 'bg-emerald-100',
      text: 'text-emerald-700',
      border: 'border-emerald-200',
      label: 'WIC'
    },
    EBT: {
      bg: 'bg-blue-100',
      text: 'text-blue-700',
      border: 'border-blue-200',
      label: 'EBT'
    },
    USDA: {
      bg: 'bg-amber-100',
      text: 'text-amber-700',
      border: 'border-amber-200',
      label: 'USDA'
    }
  };
  const config = configs[type];
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-[10px] gap-1' : 'px-2.5 py-1 text-xs gap-1.5';
  const iconSize = size === 'sm' ? 'w-3 h-3' : 'w-3.5 h-3.5';
  return <motion.span initial={{
    opacity: 0,
    scale: 0.8
  }} animate={{
    opacity: 1,
    scale: 1
  }} className={`inline-flex items-center ${sizeClasses} ${config.bg} ${config.text} border ${config.border} rounded-full font-bold`} data-id="element-261">
      <CheckCircle2 className={iconSize} data-id="element-262" />
      {config.label}
    </motion.span>;
}